<template>
  <div class="risks">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Listado de riesgos transversales')">
        <el-row>
          <el-col :span="24">
            <el-input
              :placeholder="$t('Búsqueda por nombre del riesgo')"
              prefix-icon="el-icon-search"
              v-model="search"
              class="search"
              size="medium"
              @keydown.native.enter.prevent
            ></el-input>
            <el-button
              v-if="isAdmin()"
              class="right"
              size="small"
              type="primary"
              @click="createFormNuevoRiesgo()"
              icon="el-icon-edit"
            >{{$t('Nuevo Riesgo')}}</el-button>
          </el-col>
        </el-row>
        <el-row
          element-loading-text="Cargando..."
          element-loading-background="rgba(255, 255, 255)"
          v-loading="loading"
        >
          <InventarioTableEstandarizados :risks="riesgos" :search="search" :editRisk="editRisk" />
        </el-row>
        <br />
        <br />
        <center>
          <el-pagination
            :current-page="page"
            @prev-click="backPage"
            @next-click="nextPage"
            @current-change="currentPage"
            :page-size="4"
            layout="prev, pager, next"
            :total="totalPage"
          ></el-pagination>
        </center>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Imprimir riesgo')"
      :visible="dialogImprimir"
      width="20%"
    >
      <div class="text-center">
        <el-button
          icon="el-icon-document"
          :loading="isLoadingPDFTabla"
          size="small"
          type="primary"
          @click="imprimirTabla()"
        >{{$t('Vista tabla')}}</el-button>
        <el-button
          icon="el-icon-document"
          :loading="isLoadingPDFBowtie"
          size="small"
          type="primary"
          @click="imprimirBowtie()"
        >{{$t('Vista bowtie')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Creando Riesgo')"
      top="3vh"
      :visible="dialogNuevoRiesgo"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-row>
        <el-col :sm="12">
          <h1>{{$t('Configuración de riesgo')}}</h1>
          <h2 v-if="stepNuevoRiesgo === 1">{{$t('Información base')}}</h2>
          <h2 v-if="stepNuevoRiesgo === 2">{{$t('Información asociada')}}</h2>
        </el-col>
        <el-col :sm="12">
          <el-steps :active="stepNuevoRiesgo">
            <el-step title="Paso 1" :description="$t('Información base')"></el-step>
            <el-step title="Paso 2" :description="$t('Información asociada')"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <div class="first-step" v-if="stepNuevoRiesgo === 1">
        <el-card>
          <el-form :model="risk" ref="risk">
            <el-form-item :label="$t('Nombre del riesgo')" prop="nombre">
              <el-input
                class="with-help-box"
                v-model="risk.nombre"
                :placeholder="$t('Ingrese nombre del riesgo')"
                @keydown.native.enter.prevent
              ></el-input>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Nombre del riesgo')"
                width="200"
                trigger="hover"
                :content="$t('Escriba el nombre del riesgo')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Riesgo material')" prop="material">
              <el-switch
                class="with-help-box"
                v-model="risk.material"
                active-text="Sí"
                inactive-text="No"
              ></el-switch>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Riesgo material')"
                width="200"
                trigger="hover"
                :content="$t('Indique si el riesgo es material')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Riesgo medioambiental')" prop="medioambiental">
              <el-switch
                class="with-help-box"
                v-model="risk.medioambiental"
                active-text="Sí"
                inactive-text="No"
              ></el-switch>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Riesgo medioambiental')"
                width="200"
                trigger="hover"
                :content="$t('Indique si el riesgo es medioambiental')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Área al que pertenece')" prop="area">
              <el-select
                v-model="risk.area"
                :placeholder="$t('Seleccione área')"
                class="with-help-box full-width"
              >
                <el-option
                  v-for="item in areas"
                  :key="item._id"
                  :label="item.nombre"
                  :value="item.nombre.replace(/ /g, '')"
                ></el-option>
              </el-select>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Área al que pertenece')"
                width="200"
                trigger="hover"
                :content="$t('Seleccione el área a la que el riesgo pertenece')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <div class="second-step" v-if="stepNuevoRiesgo === 2">
        <InventarioBowtie
          :editable="true"
          :risk="risk"
          :addCause="addCause"
          :deleteCause="deleteCause"
          :editCause="editCause"
          :addImpact="addImpact"
          :deleteImpact="deleteImpact"
          :editImpact="editImpact"
          :addPreventiveControl="addPreventiveControl"
          :deletePreventiveControl="deletePreventiveControl"
          :editPreventiveControl="editPreventiveControl"
          :addMitigationControl="addMitigationControl"
          :deleteMitigationControl="deleteMitigationControl"
          :editMitigationControl="editMitigationControl"
          :addEvaluator="addEvaluator"
          :deleteEvaluator="deleteEvaluator"
          :editEvaluator="editEvaluator"
          :appendToBody="true"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeNuevoRiesgo()">{{$t('Cancelar')}}</el-button>
        <el-button
          type="primary"
          @click="nextStepNuevoRiesgo()"
          v-if="stepNuevoRiesgo === 1"
        >{{$t('Continuar')}}</el-button>
        <el-button @click="stepNuevoRiesgo = 1" v-if="stepNuevoRiesgo === 2">{{$t('Atrás')}}</el-button>
        <el-button
          type="primary"
          @click="createNuevoRiesgo()"
          v-if="stepNuevoRiesgo === 2"
          :loading="isLoading"
        >{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Modificando Riesgo')"
      top="3vh"
      width="99%"
      :visible="dialogEdicionRiesgo"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-row>
        <el-col :sm="12">
          <h1>{{$t('Configuración de riesgo')}}</h1>
          <h2 v-if="stepNuevoRiesgo === 1">{{$t('Información base')}}</h2>
          <h2 v-if="stepNuevoRiesgo === 2">{{$t('Información asociada')}}</h2>
        </el-col>
        <el-col :sm="12">
          <el-steps :active="stepNuevoRiesgo">
            <el-step title="Paso 1" :description="$t('Información base')"></el-step>
            <el-step title="Paso 2" :description="$t('Información asociada')"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <div class="first-step" v-if="stepNuevoRiesgo === 1">
        <el-card>
          <el-form :model="risk" ref="risk">
            <el-form-item
              :label="$t('Nombre del riesgo')"
              prop="nombre"
              @keydown.native.enter.prevent
            >
              <el-input
                class="with-help-box"
                v-model="risk.nombre"
                :placeholder="$t('Ingrese nombre del riesgo')"
                @keydown.native.enter.prevent
              ></el-input>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Nombre del riesgo')"
                width="200"
                trigger="hover"
                :content="$t('Escriba el nombre del riesgo')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Riesgo material')" prop="material">
              <el-switch
                class="with-help-box"
                v-model="risk.material"
                :active-text="$t('Sí')"
                :inactive-text="$t('No')"
              ></el-switch>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Riesgo material')"
                width="200"
                trigger="hover"
                :content="$t('Indique si el riesgo es material')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Riesgo medioambiental')" prop="medioambiental">
              <el-switch
                class="with-help-box"
                v-model="risk.medioambiental"
                active-text="Sí"
                inactive-text="No"
              ></el-switch>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Riesgo medioambiental')"
                width="200"
                trigger="hover"
                :content="$t('Indique si el riesgo es medioambiental')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Área al que pertenece')" prop="area">
              <el-select
                v-model="risk.area"
                :placeholder="$t('Seleccione área')"
                class="with-help-box full-width"
              >
                <el-option
                  v-for="item in areas"
                  :key="item._id"
                  :label="item.nombre"
                  :value="item.nombre.replace(/ /g, '')"
                ></el-option>
              </el-select>
              <el-popover
                class="help-box"
                placement="right"
                :title="$t('Área al que pertenece')"
                width="200"
                trigger="hover"
                :content="$t('Seleccione el área a la que el riesgo pertenece')"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <div class="second-step" v-if="stepNuevoRiesgo === 2">
        <InventarioBowtie
          :editable="true"
          :risk="risk"
          :addCause="addCause"
          :deleteCause="deleteCause"
          :editCause="editCause"
          :addImpact="addImpact"
          :deleteImpact="deleteImpact"
          :editImpact="editImpact"
          :addPreventiveControl="addPreventiveControl"
          :deletePreventiveControl="deletePreventiveControl"
          :editPreventiveControl="editPreventiveControl"
          :addMitigationControl="addMitigationControl"
          :deleteMitigationControl="deleteMitigationControl"
          :editMitigationControl="editMitigationControl"
          :addEvaluator="addEvaluator"
          :deleteEvaluator="deleteEvaluator"
          :editEvaluator="editEvaluator"
          :appendToBody="true"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteRiesgo" icon="el-icon-delete">{{$t('Eliminar')}}</el-button>
        <el-button @click="closeEdicionRiesgo">{{$t('Cancelar')}}</el-button>
        <el-button
          type="primary"
          @click="nextStepNuevoRiesgo()"
          v-if="stepNuevoRiesgo === 1"
        >{{$t('Continuar')}}</el-button>
        <el-button @click="stepNuevoRiesgo = 1" v-if="stepNuevoRiesgo === 2">{{$t('Atrás')}}</el-button>

        <el-button
          type="primary"
          @click="saveEdicionRiesgo"
          v-if="stepNuevoRiesgo === 2"
        >{{$t('Guardar')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid/v4";
import { Loading } from "element-ui";
import ImagesLoaded from "vue-images-loaded";
import { mapGetters } from "vuex";
import InventarioBowtie from "@/components/InventarioBowtie.vue";
import InventarioTableEstandarizados from "@/components/InventarioTableEstandarizados.vue";
import axios from "axios";

export default {
  name: "risks",
  data() {
    return {
      dialogImprimir: false,
      isLoading: false,
      isLoadingPDFTabla: false,
      isLoadingPDFBowtie: false,
      stepNuevoRiesgo: 1,
      dialogEdicionRiesgo: false,
      dialogNuevoRiesgo: false,
      riesgoIDPDF: "",
      risk: {
        area: "",
        faena_id: this.$store.getters.role.faena_id,
        nombre: "",
        tipo: "seguridad",
        evento_no_deseado: "",
        control_adicional: "",
        energia: "",
        calculo_mfl: "",
        peligro: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        justificacion_evaluacion: "",
        kri: [],
        escenario_residual: "",
        escenario_mfl: "",
        medioambiental: false,
        medioambiente: {},
        evaluadores: [],
        sin_controles: {
          severidad: 0,
          probabilidad: 0
        },
        con_controles: {
          severidad: 0,
          probabilidad: 0
        },
        responsable: "",
        fecha: ""
      },
      totalPage: 0,
      paginar: false,
      search: "",
      page: 1,
      loading: false,
      riesgos: []
    };
  },
  components: {
    InventarioBowtie,
    InventarioTableEstandarizados
  },
  directives: {
    ImagesLoaded
  },
  computed: {
    ...mapGetters({
      areas: "areas"
    })
  },
  watch: {
    search: function() {
      this.loading = true;
      this.debounceInputSearch();
    }
  },
  created() {
    this.loading = true;
    this.$store.dispatch(
      "setTitle",
      this.$t("Administración de riesgos transversales")
    );
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Inventario de riesgos HSE online")
    );
    this.$store.dispatch("getAreasFaena");
    this.listadoRiesgos(1, this.search);
  },
  methods: {
    debounceInputSearch: _.debounce(function() {
      this.page = 1;
      this.listadoRiesgos(this.page, this.search);
    }, 1200),
    currentPage(page) {
      this.page = page;
      this.listadoRiesgos(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoRiesgos(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoRiesgos(page, this.search);
    },
    listadoRiesgos(page, search) {
      this.loading = true;
      var self = this;
      axios
        .get(
          `/inventarios/getAllRisks/${
            this.$store.getters.role.faena_id
          }/${page}/${search === "" ? undefined : search}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then(response => {
          self.riesgos = response.data.results;
          self.totalPage = response.data.total;
          self.paginar = response.data.paginar;
          self.loading = false;
        });
    },
    editRisk(risk) {
      this.dialogEdicionRiesgo = true;
      this.risk = risk;
    },
    isAdmin() {
      return this.$store.getters.role.admin;
    },
    handleClose() {
      this.dialogImprimir = false;
      this.dialogNuevoRiesgo = false;
      this.dialogEdicionRiesgo = false;
    },
    resetFormRiesgo() {
      this.stepNuevoRiesgo = 1;
      this.risk = {
        area: "",
        faena_id: this.$store.getters.role.faena_id,
        nombre: "",
        tipo: "seguridad",
        evento_no_deseado: "",
        control_adicional: "",
        energia: "",
        calculo_mfl: "",
        peligro: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        justificacion_evaluacion: "",
        kri: [],
        escenario_residual: "",
        escenario_mfl: "",
        medioambiental: false,
        medioambiente: {},
        evaluadores: [],
        sin_controles: {
          severidad: 0,
          probabilidad: 0
        },
        con_controles: {
          severidad: 0,
          probabilidad: 0
        },
        responsable: "",
        fecha: ""
      }
    },
    createFormNuevoRiesgo() {
      this.dialogNuevoRiesgo = true;
    },
    createNuevoRiesgo() {
      this.isLoading = true;
      if (!this.isRiskReady(this.risk)) {
        this.isLoading = false;
        this.$alert(
          this.$t("Debes completar la información de todo el riesgo"),
          this.$t("Atención"),
          {
            type: "error"
          }
        );
        return;
      }
      this.$store.dispatch("saveRisk", this.risk).then(response => {
        if (!response.status) {
          this.$alert(
            this.$t(
              "Lo sentimos, riesgo no pudo ser ingresado. Intente nuevamente"
            ),
            this.$t("Atención"),
            {
              type: "error"
            }
          );
          return;
        }
        this.listadoRiesgos(this.page, this.search);
        this.dialogNuevoRiesgo = false;
        this.$alert(
          this.$t("Riesgo ingresado exitosamente"),
          this.$t("Atención"),
          {
            type: "success"
          }
        );
        this.resetFormRiesgo();
        this.dialogNuevoRiesgo = false;
        this.isLoading = false;
      });
    },
    closeNuevoRiesgo() {
      this.$confirm(
        this.$t(
          "Se perderán todos los cambios que haya realizado. ¿Está seguro de cancelar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.resetFormRiesgo();
        this.dialogNuevoRiesgo = false;
      });
    },
    nextStepNuevoRiesgo() {
      if (this.risk.nombre && this.risk.area) {
        this.stepNuevoRiesgo = 2;
      } else {
        this.$alert(
          this.$t("Debes ingresar todos los datos antes de continuar"),
          this.$t("Atención"),
          {
            type: "error"
          }
        );
      }
    },
    riskItem(risk) {
      if (!this.dialogImprimir) {
        this.risk = JSON.parse(JSON.stringify(risk));
        this.risk = {
          ...this.risk,
          medioambiental: this.risk.medioambiental || false,
          area: this.risk.area
        };
        this.dialogEdicionRiesgo = true;
      }
    },
    closeEdicionRiesgo() {
      this.resetFormRiesgo();
      this.dialogEdicionRiesgo = false;
    },
    saveEdicionRiesgo() {
      this.$confirm(
        this.$t(
          "Se guardarán los cambios realizados. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        const loadingInstance = Loading.service({ fullscreen: true });
        this.$store.dispatch("editRisk", this.risk).then(response => {
          loadingInstance.close();
          if (!response.status) {
            this.$alert(
              this.$t(
                "Lo sentimos, riesgo no pudo ser actualizado. Intente nuevamente"
              ),
              this.$t("Atención"),
              {
                type: "error"
              }
            );
            return;
          }
          this.listadoRiesgos(this.page, this.search);
          this.resetFormRiesgo();
          this.dialogEdicionRiesgo = false;
          this.$alert(
            this.$t("Riesgo actualizado exitosamente"),
            this.$t("Atención"),
            {
              type: "success"
            }
          );
        });
      });
    },
    deleteRiesgo() {
      this.$confirm(
        this.$t(
          "Se eliminará el riesgo de la plataforma. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        const loadingInstance = Loading.service({ fullscreen: true });
        this.$store.dispatch("deleteRisk", this.risk._id).then(response => {
          loadingInstance.close();
          if (!response.status) {
            this.$alert(
              this.$t(
                "Lo sentimos, riesgo no pudo ser eliminado. Intente nuevamente"
              ),
              this.$t("Atención"),
              {
                type: "error"
              }
            );
            return;
          }
          this.listadoRiesgos(this.page, this.search);
          this.dialogEdicionRiesgo = false;
          this.$alert(
            this.$t("Riesgo eliminado exitosamente"),
            this.$t("Atención"),
            {
              type: "success"
            }
          );
        });
      });
    },
    addCause(causa) {
      const cause = {
        id: uuid(),
        nombre: causa
      };
      this.risk.causas.push(cause);
    },
    deleteCause(causaId) {
      const causeIndex = this.risk.causas.findIndex(
        cause => cause.id === causaId
      );
      Vue.delete(this.risk.causas, causeIndex);
    },
    editCause(causa, causaID) {
      const causeIndex = this.risk.causas.findIndex(
        cause => cause.id === causaID
      );
      Vue.set(this.risk.causas, causeIndex, {
        ...this.risk.causas[causeIndex],
        nombre: causa
      });
    },
    addImpact(impacto) {
      const impact = {
        id: uuid(),
        ...impacto
      };
      this.risk.impactos.push(impact);
    },
    deleteImpact(impactoId) {
      const impactIndex = this.risk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      Vue.delete(this.risk.impactos, impactIndex);
    },
    editImpact(impacto, impactoId) {
      const impactIndex = this.risk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      Vue.set(this.risk.impactos, impactIndex, {
        ...this.risk.impactos[impactIndex],
        categoria: impacto.categoria,
        descripcion: impacto.descripcion,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl
      });
    },
    addPreventiveControl(causasId, control, critico) {
      const preventiveControlId = uuid();
      causasId.forEach(causaId => {
        const causeIndex = this.risk.causas.findIndex(
          cause => cause.id === causaId
        );
        if (!this.risk.causas[causeIndex].controles_preventivos) {
          Vue.set(this.risk.causas, causeIndex, {
            ...this.risk.causas[causeIndex],
            controles_preventivos: []
          });
        }
        const controlPreventivo = {
          id: preventiveControlId,
          nombre: control,
          critico
        };
        this.risk.causas[causeIndex].controles_preventivos.push(
          controlPreventivo
        );
      });
    },
    deletePreventiveControl(controlId) {
      this.risk.causas.forEach((cause, causeIndex) => {
        const controlIndex = cause.controles_preventivos.findIndex(
          control => control.id === controlId
        );
        if (controlIndex >= 0) {
          Vue.delete(
            this.risk.causas[causeIndex].controles_preventivos,
            controlIndex
          );
        }
      });
    },
    editPreventiveControl(control, controlId) {
      this.risk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            control => control.id === controlId
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            console.log(`actualiza ${cause.nombre} en ${control.nombre}`);
            Vue.set(
              this.risk.causas[causeIndex].controles_preventivos,
              controlIndex,
              {
                ...this.risk.causas[causeIndex].controles_preventivos[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico
              }
            );
          } else {
            // Agregar control a causa
            console.log(
              `${this.$t("agregando")} ${cause.nombre} ${this.$t("en")} ${
                control.nombre
              }`
            );
            const controlPreventivo = {
              id: controlId,
              nombre: control.nombre,
              critico: control.critico
            };
            console.log(control);
            if (!this.risk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.risk.causas, causeIndex, {
                ...this.risk.causas[causeIndex],
                controles_preventivos: []
              });
            }
            this.risk.causas[causeIndex].controles_preventivos.push(
              controlPreventivo
            );
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(
              `${this.$t("borrando")} ${cause.nombre} ${this.$t("de")} ${
                control.nombre
              }`
            );
            Vue.delete(
              this.risk.causas[causeIndex].controles_preventivos,
              controlIndex
            );
          }
        }
      });
    },
    editMitigationControl(control, controlId) {
      this.risk.impactos.forEach((impact, impactIndex) => {
        // Se busca si este impacto ya tiene este control asignado
        let controlIndex = -1;
        if (impact.controles_mitigadores) {
          controlIndex = impact.controles_mitigadores.findIndex(
            control => control.id === controlId
          );
        }

        // El control editado, tiene asociada este impacto?
        if (control.impacto === impact.id) {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            console.log(
              `${this.$t("actualiza")} ${impact.categoria} ${this.$t("en")} ${
                control.nombre
              }`
            );
            Vue.set(
              this.risk.impactos[impactIndex].controles_mitigadores,
              controlIndex,
              {
                ...this.risk.impactos[impactIndex].controles_mitigadores[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico
              }
            );
          } else {
            // Agregar control a impacto
            console.log(
              `${this.$t("agregando")} ${impact.categoria} ${this.$t("en")} ${
                control.nombre
              }`
            );
            const controlMitigador = {
              id: uuid(),
              nombre: control.nombre,
              critico: control.critico
            };
            this.risk.impactos[impactIndex].controles_mitigadores.push(
              controlMitigador
            );
          }
          // El control editado no tiene este impacto asociada actualmente
        } else {
          // Este control ya existe en el impacto?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(
              `${this.$t("borrando")} ${impact.categoria} ${this.$t("de")} ${
                control.nombre
              }`
            );
            Vue.delete(
              this.risk.impactos[impactIndex].controles_mitigadores,
              controlIndex
            );
          }
        }
      });
    },
    addMitigationControl(impactoId, control, critico) {
      const impactIndex = this.risk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      if (!this.risk.impactos[impactIndex].controles_mitigadores) {
        Vue.set(this.risk.impactos, impactIndex, {
          ...this.risk.impactos[impactIndex],
          controles_mitigadores: []
        });
      }
      const controlMitigador = {
        id: uuid(),
        nombre: control,
        critico
      };
      this.risk.impactos[impactIndex].controles_mitigadores.push(
        controlMitigador
      );
    },
    deleteMitigationControl(impactoId, controlId) {
      const impactIndex = this.risk.impactos.findIndex(
        impact => impact.id === impactoId
      );
      const controlIndex = this.risk.impactos[
        impactIndex
      ].controles_mitigadores.findIndex(control => control.id === controlId);
      Vue.delete(
        this.risk.impactos[impactIndex].controles_mitigadores,
        controlIndex
      );
    },
    addEvaluator(pEvaluator) {
      if (!this.risk.evaluadores) {
        this.risk.evaluadores = [];
      }
      const evaluator = {
        ...pEvaluator,
        id: uuid()
      };
      this.risk.evaluadores.push(evaluator);
    },
    editEvaluator(evaluator, evaluadorId) {
      const evaluatorIndex = this.risk.evaluadores.findIndex(
        evaluator => evaluator.id === evaluadorId
      );
      Vue.set(this.risk.evaluadores, evaluatorIndex, {
        ...this.risk.evaluadores[evaluatorIndex],
        nombre: evaluator.nombre,
        rut: evaluator.rut,
        cargo: evaluator.cargo,
        empresa: evaluator.empresa
      });
    },
    deleteEvaluator(evaluadorId) {
      const evaluatorIndex = this.risk.evaluadores.findIndex(
        evaluator => evaluator.id === evaluadorId
      );
      Vue.delete(this.risk.evaluadores, evaluatorIndex);
    },
    isRiskReady(risk) {
      let isReady = true;
      if (!risk.causas || risk.causas.length === 0) {
        return false;
      }
      if (!risk.impactos || risk.impactos.length === 0) {
        return false;
      }
      risk.causas.forEach(causa => {
        if (
          !causa.controles_preventivos ||
          causa.controles_preventivos.length === 0
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }
      risk.impactos.forEach(impacto => {
        if (
          !impacto.controles_mitigadores ||
          impacto.controles_mitigadores.length === 0
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }
      return true;
    },
    layout() {
      this.$refs.cpt1.layout("fitRows");
    },
    getOptions() {
      return {
        layoutMode: "fitRows"
      };
    },
    imprimirTabla() {
      this.isLoadingPDFTabla = true;
      this.$store
        .dispatch("getPDFRiesgoTabla", this.riesgoIDPDF)
        .then(response => {
          this.isLoadingPDFTabla = false;
          this.dialogImprimir = false;
          this.riesgoIDPDF = "";
          // window.open(response);
        });
    },
    imprimirBowtie() {
      this.isLoadingPDFBowtie = true;
      this.$store
        .dispatch("getPDFRiesgoBowtie", this.riesgoIDPDF)
        .then(response => {
          this.isLoadingPDFBowtie = false;
          this.dialogImprimir = false;
          this.riesgoIDPDF = "";
          // window.open(response);
        });
    }
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  display: block;
}
</style>

<style scoped>
.container-risks {
  margin-top: 40px;
  min-height: 300px;
}

.actions {
  margin-top: 5%;
}

.item {
  width: 160px;
  padding: 20px;
  opacity: 0.6;
  transition: 0.2s opacity;
}

.item:hover {
  cursor: pointer;
  opacity: 1;
}

.item img {
  width: 140px;
}
.right {
  text-align: right;
}
.search {
  max-width: 450px;
  float: left;
}
.content {
  min-height: 50vh;
}
</style>
